"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

require("./BB8Breadcrumbs.scss");

var BB8MainPage_1 = __importDefault(require("./BB8MainPage"));

var BB8Breadcrumbs = function BB8Breadcrumbs(props) {
  return react_1.default.createElement(BB8MainPage_1.default.Padded, null, react_1.default.createElement("ol", {
    className: 'bb8-breadcrumbs-wrapper'
  }, react_1.default.createElement("li", null, react_1.default.createElement(react_router_dom_1.NavLink, {
    to: "/"
  }, "Home")), props.routes && props.routes.length ? props.routes.map(function (route, i) {
    return react_1.default.createElement("li", {
      key: route.path
    }, i === props.routes.length - 1 ? react_1.default.createElement("span", null, route.title) : react_1.default.createElement(react_router_dom_1.NavLink, {
      to: route.path
    }, route.title));
  }) : undefined));
};

exports.default = BB8Breadcrumbs;